export class OrderOffer {
    /** Link to {@link Offer#id} */
    id: number;
    name: string;
    nameI18n: {[id: string]: string};
    /** Link to {@link OrderItem#id} */
    orderItemId: number;
    total: number;
}
